const selfRecordingActions = {
  addVideo: 'addVideo',
  setIsRecording: 'setIsRecording',
  setIsUploading: 'setIsUploading',
  setSelectedQuestion: 'setSelectedQuestion',
  deleteAllVideos: 'deleteAllVideos',
  deleteVideo: 'deleteVideo',
  setVaultId: 'setVaultId',
  setAlbumId: 'setAlbumId',
  newClip: 'newClip',
  setReadyForNextStep: 'setReadyForNextStep',
  updateInformation: 'updateInformation',
  videoFailed: 'videoFailed',
  setMode: 'setMode',
  setMediaStream: 'setMediaStream',
  cleanState: 'cleanState',
  updateAudioOnly: 'updateAudioOnly',
  setBatchId: 'setBatchId',
  setPositionInBatchToClip: 'setPositionInBatchToClip',
  setClipNumber: 'setClipNumber',
  addUpload: 'addUpload',
  updateUpload: 'updateUpload',
  removeUpload: 'removeUpload',
  setUploadResponse: 'setUploadResponse',
  setRecordingState: 'setRecordingState',
  setEntryMeta: 'setEntryMeta',
};

export { selfRecordingActions };
